(() => {
  const language = document.documentElement.lang.toLowerCase().split('-')[0];

  // Translation order: Dutch, French, Spanish, German.
  const languageIndex = ['nl', 'fr', 'es', 'de'].indexOf(language);
  if (languageIndex === -1) return;

  const labels = {
    'Cart': ['Winkelwagen', 'Panier', 'Carrito', 'Warenkorb'],
    'Your order': ['Je bestelling', 'Votre commande', 'Tu pedido', 'Deine Bestellung'],
    'Stack with': ['Combineer met', 'À associer avec', 'Combina con', 'Kombiniere mit'],
    'Color': ['Kleur', 'Couleur', 'Color', 'Farbe'],
    'Remove': ['Verwijderen', 'Supprimer', 'Eliminar', 'Entfernen'],
    'View Cart': ['Bekijk winkelwagen', 'Voir le panier', 'Ver carrito', 'Warenkorb ansehen'],
    'Checkout': ['Afrekenen', 'Commander', 'Finalizar compra', 'Zur Kasse'],
    'Subtotal': ['Subtotaal', 'Sous-total', 'Subtotal', 'Zwischensumme'],
    'Free Gift': ['Gratis cadeau', 'Cadeau offert', 'Regalo gratis', 'Gratisgeschenk'],
    'Free Shipping': ['Gratis verzending', 'Livraison offerte', 'Envío gratis', 'Versand gratis'],
    'Sticker Pack': ['Stickerset', 'Lot d’autocollants', 'Pack de pegatinas', 'Sticker-Set'],
    'Mini Travel Box': ['Mini-reisdoosje', 'Mini-boîte de voyage', 'Caja de viaje mini', 'Mini-Reisebox'],
    'Travel Box': ['Reisdoosje', 'Boîte de voyage', 'Caja de viaje', 'Reisebox'],
    'Order before 10PM, shipped same day.': [
      'Bestel vóór 22.00 uur, dan verzenden we je bestelling dezelfde dag.',
      'Commandez avant 22 h pour une expédition le jour même.',
      'Pide antes de las 22:00 y enviaremos tu pedido el mismo día.',
      'Vor 22 Uhr bestellen – Versand am selben Tag.',
    ],
    'Taxes included. Shipping calculated at checkout.': [
      'Inclusief btw. Verzendkosten worden berekend bij het afrekenen.',
      'Taxes incluses. Frais de livraison calculés lors du paiement.',
      'Impuestos incluidos. Los gastos de envío se calculan al finalizar la compra.',
      'Inkl. MwSt. Versandkosten werden an der Kasse berechnet.',
    ],
    'You have unlocked something great!': [
      'Je hebt een cadeau vrijgespeeld!',
      'Vous avez débloqué un cadeau !',
      '¡Has desbloqueado un regalo!',
      'Du hast ein Geschenk freigeschaltet!',
    ],
  };

  const remaining = [
    amount => `Nog ${amount} tot je volgende cadeau!`,
    amount => `Plus que ${amount} pour débloquer votre prochain cadeau !`,
    amount => `¡Te faltan ${amount} para desbloquear tu próximo regalo!`,
    amount => `Nur noch ${amount} bis zu deinem nächsten Geschenk!`,
  ];

  const savings = [
    percent => `Bespaar ${percent} %`,
    percent => `Économisez ${percent} %`,
    percent => `Ahorra un ${percent} %`,
    percent => `${percent} % sparen`,
  ];

  const itemLabels = [
    ['artikel', 'artikelen'],
    ['article', 'articles'],
    ['artículo', 'artículos'],
    ['Artikel', 'Artikel'],
  ];

  const translations = new Map(
    Object.entries(labels).map(([source, values]) => [
      source.toLowerCase(),
      values[languageIndex],
    ])
  );

  let drawer;
  let scheduled = false;

  function translateText(source) {
    const label = translations.get(source.toLowerCase());
    if (label) return label;

    const progress = source.match(/^You are\s+(.+?)\s+away from something great!$/i);
    if (progress) return remaining[languageIndex](progress[1]);

    const checkout = source.match(/^Checkout(\s*[·–—-]\s*.+)$/i);
    if (checkout) return translations.get('checkout') + checkout[1];

    const subtotal = source.match(/^Subtotal\s*\((\d+)\s+items?\)$/i);
    if (subtotal) {
      const count = subtotal[1];
      const itemLabel = itemLabels[languageIndex][Number(count) === 1 ? 0 : 1];
      return `${translations.get('subtotal')} (${count} ${itemLabel})`;
    }

    const discount = source.match(/^Save\s+(\d+(?:[.,]\d+)?)\s*%$/i);
    if (discount) return savings[languageIndex](discount[1]);
  }

  function translateDrawer() {
    scheduled = false;
    if (!drawer?.isConnected) return;

    const walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      const node = walker.currentNode;

      if (node.parentElement.closest('script, style, textarea, [contenteditable]')) {
        continue;
      }

      const source = node.nodeValue.trim();
      const translated = translateText(source);

      if (translated && translated !== source) {
        node.nodeValue = node.nodeValue.replace(source, () => translated);
      }
    }
  }

  function scheduleTranslation() {
    if (scheduled) return;

    scheduled = true;
    requestAnimationFrame(translateDrawer);
  }

  const observer = new MutationObserver(scheduleTranslation);

  function connectDrawer() {
    const currentDrawer = document.querySelector('#rebuy-cart');
    if (!currentDrawer) return;

    if (currentDrawer !== drawer) {
      observer.disconnect();
      drawer = currentDrawer;
      observer.observe(drawer, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    scheduleTranslation();
  }

  document.addEventListener('rebuy:smartcart.ready', connectDrawer);
  document.addEventListener('rebuy:cart.change', connectDrawer);
  connectDrawer();
})();